module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Mail-@-bbfd933f038ad65b8675d2c212b63914.svg";